import { ActionType } from "../../models/ActionType";
import { LoginRequest } from "../../models/LoginRequest";
import { AuthDetails } from "../../models/AuthDetails";

// Sends only the Google OAuth access token; the API verifies it with Google
// and derives the user's identity server-side.
export const LoginWithGoogle =
  (accessToken: string) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      const resp = await api.post("auth/login/external?jwt=1", {
        accessToken,
      });
      dispatch({ type: ActionType.LOGIN, payload: resp });
      return resp;
    } catch (err) {
      dispatch({ type: ActionType.LOGIN_FAILED, payload: err });
      return null;
    }
  };

export const Login =
  (request: LoginRequest) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      const resp: AuthDetails = await api.post("auth/login?jwt=1", request);
      dispatch({ type: ActionType.LOGIN, payload: resp });
      return resp;
    } catch (err) {
      dispatch({ type: ActionType.LOGIN_FAILED, payload: err });
      return null;
    }
  };

export const cdpLogin =
  (token: string) =>
  async (dispatch: Function, _getState: Function, api: any) => {
    try {
      const resp: AuthDetails = await api.get(`auth/login/cdp/${token}`);
      dispatch({ type: ActionType.LOGIN, payload: resp });
      return resp;
    } catch (err) {
      dispatch({ type: ActionType.LOGIN_FAILED, payload: err });
      return null;
    }
  };

export const getAllPermission =
  () => async (dispatch: Function, _getState: Function, api: any) => {
    try {
      const resp = await api.get("permission/all");
      dispatch({ type: ActionType.LOGIN, payload: resp });
      return resp;
    } catch (err) {
      dispatch({ type: ActionType.LOGIN_FAILED, payload: err });
      return null;
    }
  };
